import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { TEXTURE_BINDING_BITMAP as e } from "../definitions.js";
import t from "../VertexStream.js";
import i from "./WGLBrush.js";

var s = {
  nearest: {
    defines: [],
    samplingMode: 9728,
    mips: !1
  },
  bilinear: {
    defines: [],
    samplingMode: 9729,
    mips: !1
  },
  bicubic: {
    defines: ["bicubic"],
    samplingMode: 9729,
    mips: !1
  },
  trilinear: {
    defines: [],
    samplingMode: 9987,
    mips: !0
  }
},
    n = function n(e, t, i) {
  if ("dynamic" === i.samplingMode) {
    var _i = e.state,
        _n = t.resolution / t.pixelRatio / _i.resolution,
        _a = Math.round(e.pixelRatio) !== e.pixelRatio,
        r = _n > 1.05 || _n < .95;

    return _i.rotation || r || _a || t.isSourceScaled || t.rotation ? s.bilinear : s.nearest;
  }

  return s[i.samplingMode];
};

var a = /*#__PURE__*/function (_i2) {
  _inherits(a, _i2);

  var _super = _createSuper(a);

  function a() {
    var _this;

    _classCallCheck(this, a);

    _this = _super.apply(this, arguments), _this._desc = {
      vsPath: "raster/bitmap",
      fsPath: "raster/bitmap",
      attributes: new Map([["a_position", 0], ["a_texcoord", 1]])
    };
    return _this;
  }

  _createClass(a, [{
    key: "dispose",
    value: function dispose() {
      this._quad && this._quad.dispose();
    }
  }, {
    key: "prepareState",
    value: function prepareState(_ref, t) {
      var e = _ref.context;
      e.setBlendingEnabled(!0), "additive" === t.blendFunction ? e.setBlendFunctionSeparate(1, 1, 1, 1) : e.setBlendFunctionSeparate(1, 771, 1, 771), e.setColorMask(!0, !0, !0, !0), e.setStencilWriteMask(0), e.setStencilTestEnabled(!0), e.setStencilFunction(514, t.stencilRef, 255);
    }
  }, {
    key: "draw",
    value: function draw(i, s) {
      var _a2 = i.context,
          r = i.renderingOptions,
          o = i.painter;
      if (!s.source) return;
      i.timeline.begin(this.name), this._quad || (this._quad = new t(_a2, [0, 0, 1, 0, 0, 1, 1, 1]));
      var d = n(i, s, r),
          c = o.materialManager.getProgram(i, this._desc, d.defines),
          l = s.coordScale,
          m = s.computedOpacity,
          p = s.transforms;
      s.setSamplingProfile(d), s.bind(i.context, e), _a2.useProgram(c), c.setUniformMatrix3fv("u_dvsMat3", p.dvs), c.setUniform1i("u_texture", e), c.setUniform2fv("u_coordScale", l), c.setUniform1f("u_opacity", m), this._quad.draw(), i.timeline.end(this.name);
    }
  }]);

  return a;
}(i);

export { a as default };